import React from 'react';
import { arrayOf, element } from 'prop-types';

const Tabs = ({ children, ...props }) => (
  <nav
    id="basic-tab-bar"
    className="mdc-tab-bar"
    {...props}
  >
    {children}
  </nav>
);

Tabs.propTypes = {
  children: arrayOf(element).isRequired,
};

export default Tabs;
